import firebase from 'firebase';

export const collection = (selectedCollection) =>
  firebase.firestore().collection(selectedCollection);

export const collectionGroup = (selectedCollection) =>
  firebase.firestore().collectionGroup(selectedCollection);
